import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/centos': {
    width: 447,
    height: 512,
    paths: [
      {
        d: 'M289.6 97.8L321.2 129.5 244.9 206V97.8H289.6zM127.2 129.5L203.5 206V97.8H158.8L127.2 129.5zM168.7 87.9H213.4V215.8L224.2 226.6 235 215.8V87.9H279.7L224.2 32.3 168.7 87.9zM194.9 256L184.1 245.2H55.5V200.4L0 256 55.5 311.6V266.8H184.1L194.9 256zM274.2 235.3H382.1V190.5L350.5 158.8 274.2 235.3zM447.5 256L392 200.4V245.2H264.3L253.5 256 264.3 266.8H392V311.6L447.5 256zM65.4 176.5L97.9 144.8 188.2 235.3H203.5V220L113.2 129.5 144.8 97.8H65.4V176.5zM382.1 97.8H303.6L335.2 129.5 244.9 220V235.3H260.2L350.5 144.8 382.1 176.5V97.8zM203.5 414.2V306.1L127.2 382.6 158.8 414.3H203.5zM65.4 235.3H174.2L97.9 158.8 65.4 190.5V235.3zM382.1 335.5L350.5 367.2 260.2 276.7H244.9V292L335.2 382.5 303.6 414.2H382.1V335.5zM382.1 276.7H274.2L350.5 353.2 382.1 321.5V276.7zM321.2 382.5L244.9 306V414.1H289.6L321.2 382.5zM97.9 353.2L174.2 276.7H65.4V321.5L97.9 353.2zM279.7 424.1H235V296.2L224.2 285.4 213.4 296.2V424.1H168.7L224.2 479.7 279.7 424.1zM113.2 382.5L203.5 292V276.7H188.2L97.9 367.2 65.4 335.5V414.2H144.8L113.2 382.5z'
      }
    ]
  }
})
